module.exports = __webpack_public_path__ + "img/epr@2x.e4139b96.webp";